import { initialCrudModelBaseState, CrudModelBase } from '@/shared/models/cruds.models'
import { AppliedBillableConceptResponse } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.dto'
import { CommonLaboratoryDatasource } from '@/shared/resources/datasources/common/common-laboratory-datasource'
import { billingModalDeliveryNotesCrudGridColumnDefs } from '@/modules/billing-module/components/modal/delivery-notes/crud/components/grid/config/billing-modal-delivery-notes-crud-grid.column-defs'
import NumericCellEditor from '@/cellEditors/numeric/numeric-cell-editor.vue'
import CheckIconCellEditor from '@/cellEditors/check-icon/check-icon-cell-editor.vue'

export interface AppliedBillableConceptChangedEvent {
    field: string
    data: AppliedBillableConceptResponse
    oldValue: any
    newValue: any
}

export interface BillingModalDeliveryNotesCrudGridState<R = AppliedBillableConceptResponse> extends CrudModelBase<R, CommonLaboratoryDatasource<R>> {
    frameworkComponents: Record<string, any>
}
export const initialBillingModalDeliveryNotesCrudGrid =
    (): BillingModalDeliveryNotesCrudGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.billing.grid.deliveryNotesCRUDModal',
        columnsDef: billingModalDeliveryNotesCrudGridColumnDefs(),
        frameworkComponents: {
            numericCellEditor: NumericCellEditor,
            checkIconCellEditor: CheckIconCellEditor
        }
    })
